import { createContext, useContext } from "react";
export const TeachingMomentsContext = createContext({ disabled: false });
/**
 * Returns the teaching moments context provided by the surrounding modular tool framework.
 * @returns The current teaching moments context.
 */
export function useTeachingMomentsContext() {
    return useContext(TeachingMomentsContext);
}
//# sourceMappingURL=teachingMomentsContext.js.map